(function (angular) {
    let ScrollToElement = (function () {
        function ScrollToElement() {
            this.init.apply(this, arguments);
        }

        ScrollToElement.prototype = {
            /**
             *
             * @param $scope{angular.IScope}
             * @param $element{JQuery}
             * @param $timeout{angular.ITimeoutService}
             * @param $ionicScrollDelegate{$ionicScrollDelegate}
             */
            init: function ($scope, $element, $timeout, $ionicScrollDelegate) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$element = $element;
                this.$timeout = $timeout;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.formField = $scope.formField || 'md-input-container';
                
                // Don't support this feature on iOS browser
                if(window['cordova'] || ionic.Platform.isAndroid()){
                    this.bindEvents();
                }
            },

            /**
             * Get scroller
             * @return {JQuery}
             */
            scroller(){
                let scroller = this.$scope.scroller||'.overflow-scroll';
                return $(scroller);
            },
            /**
             * 
             * @return {JQuery}
             */
            inputContainer(){
                if (this.$scope.input) {
                    return $(this.$element).find(this.$scope.input);
                } else {
                    return $(this.$element);
                }
            },
            getContainer(){
                return this.inputContainer().closest(this.formField);
            },
            bindEvents: function () {
                let _this = this;

                // forceElementInViewport when window is resized  
                function onWindowResize() {
                    // debounceTime 100
                    if(_this.windowResizeTimeout){
                        _this.$timeout.cancel(_this.windowResizeTimeout);
                    }
                    _this.windowResizeTimeout = _this.$timeout(()=>{
                        forceElementInViewport();
                    },100);
                }
                
                function forceElementInViewport(){
                    if(_this.$scope.useIonicScroll){
                        _this.fixIonicScroll();
                    } else{
                        _this.forceElementInViewport();
                    }
                   
                }
                
                let inputContainer = this.inputContainer();
                inputContainer.on('focus.scroll-to-element', () => {
                    window.addEventListener('resize', onWindowResize);
                    forceElementInViewport();
                });
                inputContainer.on('blur.scroll-to-element', () => {
                    // Update ionic-scroll when  blur input
                    if (this.$scope.useIonicScroll) {
                        this.$timeout(() => {
                            this.$ionicScrollDelegate.resize();
                        }, 800);
                    }
                    

                            
                    window.removeEventListener('resize', onWindowResize);
                    if(this.windowResizeTimeout){
                        this.$timeout.cancel(this.windowResizeTimeout);
                    }

                   
                });



                // Unbind Events when scope is destroy
                this.$scope.$on('$destroy', () => {
                    inputContainer.off('focus.scroll-to-element');
                    inputContainer.off('blur.scroll-to-element');
                    window.removeEventListener('resize', onWindowResize);
                    if(this.windowResizeTimeout){
                        this.$timeout.cancel(_this.windowResizeTimeout);
                    }
                })
            },


            /**
             * Check cell in view-port
             * @param {JQuery} container
             * @returns {boolean}
             */
            isCellContainViewPort(container) {
                let inViewPort = false;
                if (!this.isCellOutLeftViewPort(container) &&
                    !this.isCellOutRightViewPort(container) &&
                    !this.isCellOutTopViewPort(container) &&
                    !this.isCellOutBottomViewPort(container)) {
                    inViewPort = true;
                }
                return inViewPort;
            },


            /**
             * Check cell in the left
             * @param {JQuery} container
             * @returns {boolean}
             */
            isCellOutLeftViewPort(container) {
                let scroller = this.scroller(),
                    cell = container,
                    left_1 = cell.offset().left,
                    left_2 = scroller.offset().left;
                return left_1 < left_2;
            },


            /**
             * Check cell in the right
             * @param {JQuery} container
             * @returns {boolean}
             */
            isCellOutRightViewPort(container) {
                let scroller = this.scroller(),
                    cell = container,
                    left_1 = cell.offset().left,
                    right_1 = left_1 + cell.outerWidth(),
                    left_2 = scroller.offset().left,
                    right_2 = left_2 + scroller.outerWidth();
                return right_1 > right_2;
            },


            /**
             * Check cell out the bottom
             * @returns {boolean}
             * @param cell
             */
            isCellOutTopViewPort(cell) {
                let scroller = this.scroller(),
                    offset_1 = cell.offset(),
                    top_1 = offset_1.top,
                    offset_2 = scroller.offset(),
                    top_2 = offset_2.top;
                return top_1 < top_2;
            },


            /**
             * Check cell out the bottom
             * @returns {boolean}
             * @param cell
             */
            isCellOutBottomViewPort(cell) {
                let scroller = this.scroller(),
                    offset_1 = cell.offset(),
                    top_1 = offset_1.top,
                    bottom_1 = top_1 + cell.outerHeight(),
                    offset_2 = scroller.offset(),
                    top_2 = offset_2.top,
                    bottom_2 = top_2 + scroller.outerHeight();
                return bottom_1 > bottom_2;
            },
            forceElementInViewport() {
                let cell = this.getContainer();
                if (!this.isCellContainViewPort(cell)) {
                    let left = null,
                        top = null,
                        $scroller = this.scroller(),
                        scroller = $scroller[0];


                    let outDirection = {
                        left: this.isCellOutLeftViewPort(cell),
                        right: this.isCellOutRightViewPort(cell),
                        top: this.isCellOutTopViewPort(cell),
                        bottom: this.isCellOutBottomViewPort(cell)
                    };
                    if (outDirection.left) {
                        left = scroller.scrollLeft + (cell.offset().left - -$scroller.offset().left);
                    }
                    if (outDirection.right) {
                        left = scroller.scrollLeft + (cell.offset().left + cell.outerWidth()) - ($scroller.offset().left + $scroller.outerWidth());
                    }
                    if (outDirection.top) {
                        top = scroller.scrollTop - ($scroller.offset().top - cell.offset().top);
                    }
                    if (outDirection.bottom) {
                        top = scroller.scrollTop + ((cell.offset().top + cell.outerHeight()) - ($scroller.offset().top + $scroller.outerHeight()));
                    }
                    this.setScroll(left, top);
                }
            },
            /**
             *
             * @param left{number|null}
             * @param top{number|null}
             */
            setScroll(left, top) {
                let scroller = this.scroller()[0];
                if (left !== null) {
                    scroller.scrollLeft = left;
                }
                if (top !== null) {
                   scroller.scrollTop = top;
                } 
            },
            fixIonicScroll(){
                this.$ionicScrollDelegate.resize().then(()=>{
                    this.scroller()[0].scrollTop = 0;
                    let scrollTop =  this.getContainer().offset().top - this.scroller().find('.scroll').offset().top;
                    this.$ionicScrollDelegate.scrollTo(0, scrollTop);
                });
            }

        };
        ScrollToElement.$inject = ['$scope', '$element', '$timeout','$ionicScrollDelegate'];
        return ScrollToElement;
    }());

    angular.module('shared').directive('nfScrollToElement', function () {
        return {
            restrict: 'A',
            controller: ScrollToElement,
            scope: {
                scroller: '=?',
                useIonicScroll: '=?',
                formField: '=?'
            }
        };
    });

}(angular));